import { DesignPriceBrackets } from "../../../types";

export const isAvailableInCurrency = (designPricing?: DesignPriceBrackets) =>
  !!designPricing;
